import { createSelector } from 'reselect'
import { checkoutAccommodationOfferView } from 'checkout/selectors/view/accommodation'
import { isBedbankOffer } from 'lib/offer/offerTypes'

/**
 * Per-bedbank-item price/surcharge (rate inclusive total, from the item view) keyed by transaction key.
 * Consumed by svc-business only.
 * svc-order continues to re-fetch the rate from svc-bedbank.
 */
export const selectBedbankTotalsByTransactionKey = createSelector(
  (state: App.State) => checkoutAccommodationOfferView(state),
  (accommodationOfferViews): Record<string, { price: number; surcharge: number }> =>
    Object.fromEntries(
      accommodationOfferViews.data
        .filter((offerView) => offerView.offer && isBedbankOffer(offerView.offer))
        .flatMap((offerView) =>
          offerView.itemViews.map(
            (itemView) =>
              [
                itemView.item.transactionKey,
                { price: itemView.totals.price ?? 0, surcharge: itemView.totals.surcharge ?? 0 },
              ],
          ),
        ),
    ),
)
